var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RetailerConfirmationComponent',{attrs:{"title":_vm.title,"showAdditionalText":_vm.showAdditionalText,"additionalText":_vm.additionalText,"showIfHasAppointment":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }